import { accessTokenRequest, sendRequest } from '../global/global.service';
import { urlConfig } from '../../config/urlConfig';

export const getUser = (setUser, setUserData, setUserLocation) => {
  return accessTokenRequest()
    .then((response) => {
      sendRequest(urlConfig.user_url, response, 'get')
        .then((result) => {
          setUserData(getUserDataTransform(result.data));
          setUser(getUserDataTransform(result.data));
          result.data.lat &&
            result.data.lng &&
            setUserLocation({ lat: result.data.lat, lng: result.data.lng });
        })
        .catch((e) => {});
    })
    .catch((e) => {});
};

export const getUserDataTransform = (data) => {
  const user = {
    ...data,
    fName: data.first_name,
    lName: data.last_name,
    phone: data.phonenumber,
    photo: data.avatar,
  };
  return user;
};

export const registerUserDataTransform = (data) => {
  const userData = {
    first_name: data.fName,
    last_name: data.lName,
    username: data.username,
    email: data.email,
    password1: data.password,
    password2: data.confirmPassword,
  };
  return userData;
};
